export default __webpack_public_path__ + "static/media/Apple-Logo.1b71431e.jpg";